function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { Box, styled } from '@mui/material';
import { ClientPortalProtectedLinksEnum, getClientDomainProperty, LoginTypes } from '@procom-labs/common';
export var LogoWrapper = /*#__PURE__*/ React.memo(function(param) {
    var clientSettings = param.clientSettings, _param_isAuthenticated = param.isAuthenticated, isAuthenticated = _param_isAuthenticated === void 0 ? false : _param_isAuthenticated, currentProfileType = param.currentProfileType, logoWrapperStyles = param.logoWrapperStyles, sx = param.sx, children = param.children, clientPortalHostname = param.clientPortalHostname, authPortalHostname = param.authPortalHostname, loginType = param.loginType;
    var t = useTranslation('main').t;
    var homepageAnonymousUsersUrl = useMemo(function() {
        return getClientDomainProperty(clientPortalHostname, authPortalHostname, 'homepageAnonymousUsersUrl');
    }, [
        authPortalHostname,
        clientPortalHostname
    ]);
    var styledLogoComponent = useMemo(function() {
        var elem = 'div';
        if (isAuthenticated) {
            elem = RouterLink;
        } else if (homepageAnonymousUsersUrl && loginType !== LoginTypes.Client) {
            elem = 'a';
        }
        return styled(elem)(function() {
            return _object_spread({}, logoWrapperStyles);
        });
    }, [
        isAuthenticated,
        homepageAnonymousUsersUrl,
        loginType,
        logoWrapperStyles
    ]);
    if (isAuthenticated) {
        return /*#__PURE__*/ _jsx(Box, {
            component: styledLogoComponent,
            sx: sx,
            to: ClientPortalProtectedLinksEnum.Dashboard,
            "aria-label": t('common.aria.logoHomepage', {
                clientName: clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.common.name
            }),
            children: children
        });
    }
    if (homepageAnonymousUsersUrl && loginType !== LoginTypes.Client) {
        return /*#__PURE__*/ _jsx(Box, {
            component: styledLogoComponent,
            sx: sx,
            href: "".concat(homepageAnonymousUsersUrl),
            "aria-label": t('common.aria.logoHomepage', {
                clientName: clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.common.name
            }),
            children: children
        });
    }
    return /*#__PURE__*/ _jsx(Box, {
        component: styledLogoComponent,
        sx: sx,
        children: children
    });
});
